import { Link } from 'gatsby';
import FvUserPc from 'images/firstview/fv_user_pc.png';
import React, { useState, useEffect } from 'react';
import Style from 'styles/components/first_view.module.scss';

const FirstView = () => {
  const [fvKey, setFvKey] = useState(0);

  useEffect(() => {
    const handler = () => setFvKey((prev) => prev + 1);
    window.addEventListener('fv-replay', handler);
    return () => window.removeEventListener('fv-replay', handler);
  }, []);
  return (
    <section key={fvKey} className={Style.hero}>
      <video
        className={Style.hero__background}
        src="/fv_gradation_v2.mp4"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />

      {/* PC: 左にタイトル+CTA、右に画像 */}
      <div className={Style.hero__main}>
        <div className={Style.hero__text}>
          <p className={Style.hero__eyebrow}>EC Cart Service — comachicart</p>

          <h1 className={Style.hero__title}>
            作って終わりじゃない<br />
            育てる<span className={Style.hero__ec}>EC</span><br />
            <span className={Style.hero__accent}>comachicart</span>
          </h1>
        </div>

        <div className={Style.hero__visual}>
          <img className={Style.hero__img} src={FvUserPc} alt="ComachiCart ショップイメージ" />
        </div>

        <div className={Style.hero__cta}>
          <p className={Style.hero__sub}>
            初期費用 <strong>0円</strong>　月額費用 <strong>0円～</strong>
          </p>

          <Link className={Style.hero__btn} to="/application">
            無料で簡単ネットショップ開設
          </Link>

          <p className={Style.hero__note}>
            <span>クレジット決済 3.2%〜</span>
            <span>最短3分で開設</span>
            <span>メールアドレスだけで登録可能</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FirstView;
